export default {
  'releaseBankEntry.list.header.companies': 'Company',
  'releaseBankEntry.list.header.code': 'Code',
  'releaseBankEntry.list.header.description': 'Description',
  'releaseBankEntry.list.header.document': 'Document',
  'releaseBankEntry.list.header.releaseDate': 'Relea.Date',
  'releaseBankEntry.list.header.value': 'Value',
  'releaseBankEntry.list.header.account': 'Account',
  'releaseBankEntry.list.header.destination': 'Destination',
  'releaseBankEntry.domain.enums.nature_type.revenue': 'Revenue',
  'releaseBankEntry.domain.enums.nature_type.expense': 'Expense',
  'releaseBankEntry.list.header.actions': 'Action',

  'releaseBankEntry.create': 'Create New Bank Entry',
  'releaseBankEntry.searchBar.cashMovement': 'Cash Movement',

  'releaseBankEntry.form.company': 'Company',
  'releaseBankEntry.form.description': 'Description',
  'releaseBankEntry.form.documentNumber': 'Document Number',
  'releaseBankEntry.form.bankAccount': 'Bank Account',
  'releaseBankEntry.form.documentType': 'Document Type',
  'releaseBankEntry.form.planAccount': 'Plan Account',
  'releaseBankEntry.form.destination': 'Destination',
  'releaseBankEntry.form.transfer': 'Transfer',
  'releaseBankEntry.form.installmentCode': 'Installment Code',
  'releaseBankEntry.form.LaunchCode': 'LaunchCode',
  'releaseBankEntry.form.releaseDate': 'Release Date',
  'releaseBankEntry.form.conciliationDate': 'Conc.Date',
  'releaseBankEntry.form.value': '(US$) Value',

  'releaseBankEntry.create.notification.success': 'Success!',
  'releaseBankEntry.create.notification.successDescription':
    'Banking entry successfully added!',

  'releaseBankEntry.update.notification.success': 'Success!',
  'releaseBankEntry.update.notification.successDescription':
    'Bank launch changed successfully!',
};
